import React from 'react'

const Snake_Pascal = () => {
    return (
        <div className='container'>
            <h1>Program to convert the given string from snake Case to Pascal case</h1>
            <div className='containers'>
            In the above code, we have used two ways to convert the case of given string: 1. Using capwords() function; 2. Using replace() with title() function. <br /><br />

The capwords() function splits the strings, capitalize word and join the words using join. The output string is printed on the screen by using print function.<br /><br />

The second way we have used is replace() with title() function. Firstly we convert the underscore ( _ ) to empty string and then capitalise the words using title.<br /><br />


            </div>
            <div className='containers'>
          <code className='library'> import</code>  string <br />
            input_string = <code className='keywords'> 'Welcome_to_NooBGeeks'</code> <br />
            <code className='library'>   print</code>("Input string is: "+input_string + "\n") <br />
            output1 = string.capwords(input_string.replace("_"," ")).replace(" ", " ") <br />
            <code className='library'> print</code>("Output using capwords() : "+str(output1) + "\n") <br />
            output2 = input_string.replace("_", " ").title().replace(" ", " ") <br />
            <code className='library'> print</code>("Output using replace() + title() : "+str(output2))
            </div>
        </div>
    )
}

export default Snake_Pascal